import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { productNameConfig } from '@app/my-zone/config/product-name.config';
import { GenderCodeEnum, PolicyProductIdEnum, PurchasedProductInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-pet',
    templateUrl: './insurance-pet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancePetComponent implements OnInit {
    @Input() public purchasedProduct!: PurchasedProductInterface;

    public productName: string;
    public productIdEnum = PolicyProductIdEnum;
    public genderCodeEnum = GenderCodeEnum;

    public ngOnInit(): void {
        this.productName = productNameConfig[this.purchasedProduct.productId];
    }
}
